import type { CardPreviewProps } from "@/components/shapes/card-previews";
import {
  PreviewBody,
  PreviewCheckRow,
  PreviewTitle,
} from "@/components/shapes/shared/card-preview-parts";
import { GenericCardPreview } from "@/components/shapes/shared/generic-card-preview";
import { frameDisplayTitle } from "@/lib/frame-display-title";
import { todoItemsFrom } from "./todo-items";

const MAX_ROWS = 8;

/** A checklist: its title, then up to eight rows with their done state. */
export function TodoCardPreview(props: CardPreviewProps) {
  const items = todoItemsFrom(props.source.items).slice(0, MAX_ROWS);
  if (items.length === 0) return <GenericCardPreview {...props} />;
  return (
    <PreviewBody density={props.density}>
      <PreviewTitle>{frameDisplayTitle(props.frame)}</PreviewTitle>
      {items.map((item) => (
        <PreviewCheckRow key={item.id} done={item.done === true}>
          {item.text}
        </PreviewCheckRow>
      ))}
    </PreviewBody>
  );
}
